module.exports = __webpack_public_path__ + "static/media/Avatars_Other-09.5dc2c7ba.png";